import { useEffect, useState } from 'react';

const useWordInURL = (searchWord, defaultValue = false) => {
  const [isPresent, setIsPresent] = useState(defaultValue);

  useEffect(() => {
    const currentURL = window.location.href;
    setIsPresent(currentURL.includes(searchWord));
  }, [searchWord]);

  return isPresent;
};

export default useWordInURL;
